import {appModules, findAppModule} from './moduleRegistry.js';

import {getProfessionalModuleAccess, isBusinessFeatureEnabled} from './core/moduleAccess.js';

export type Route = {path: string; moduleId: string};

export function currentRoute(): Route {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const module = findAppModule(path);
  return module ? {path, moduleId: module.id} : {path, moduleId: 'unknown'};
}

export function navigate(path: string): void {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function routeLinks(showWorkspace = true, ledgerType = 'customs-invoice-matching'): string {
  const access=getProfessionalModuleAccess();
  const iconById: Record<string, string> = {tasks: '&#xE9D5;', space: '&#xE8B7;', plans: '&#xE8A5;', declarations: '&#xE8A5;', invoices: '&#xE8C3;', matching: '&#xE9D5;', ledger: '&#xE9F9;', suppliers: '&#xE822;', rebate: '&#xE9F9;', archive: '&#xE8B7;', 'legal-review': '&#xE8B6;', 'legal-litigation': '&#xE8A5;'};
  const item = (id: string): string => {
    const module = appModules.find((entry) => entry.id === id);
    if (!module) return '';
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    const modulePath = module.path.replace(/\/$/, '') || '/';
    const isLitigationPlanEditor = currentPath === '/tax-assistant/legal-litigation/plan' || currentPath.startsWith('/tax-assistant/legal-litigation/plan/');
    const active = currentPath === modulePath
      || (id === 'legal-review' && currentPath.startsWith(`${modulePath}/`))
      || (id === 'legal-litigation' && currentPath.startsWith(`${modulePath}`) && !isLitigationPlanEditor)
      || (id === 'plans' && isLitigationPlanEditor);
    return `<a class="nav-item${active ? ' active' : ''}" href="${module.path}" data-route="${module.path}"><span class="icon">${iconById[id] ?? '•'}</span>${module.title}</a>`;
  };
  if (ledgerType === 'legal-review' || (window.location.pathname.replace(/\/$/, '') || '/').startsWith('/tax-assistant/legal-litigation') || ((window.location.pathname.replace(/\/$/, '') || '/') === '/tax-assistant/plans' && new URLSearchParams(window.location.search).get('kind') === 'legal-litigation')) {
    const legalAvailable = access['legal-compliance-assistant'];
    const legalItems = `${item('legal-review')}${isBusinessFeatureEnabled('legal-litigation-ledger-v1') ? item('legal-litigation') : ''}`;
    const legalPlans = isBusinessFeatureEnabled('legal-litigation-ledger-v1') ? item('plans') : '';
    return `<div class="nav-group">${item('tasks')}${item('space')}${legalPlans}</div>${showWorkspace && legalAvailable ? `<div class="nav-group"><div class="nav-section-label">法务合规助手模块</div>${legalItems}</div>` : ''}`;
  }
  const workflowItems = ledgerType === 'invoice-ledger'
    ? `${item('invoices')}${item('archive')}`
    : `${item('declarations')}${item('invoices')}${item('matching')}${item('ledger')}${item('suppliers')}${item('rebate')}${item('archive')}`;
  // 台账方案仅在选中台账类任务时显示，未选任务或法务审核任务时隐藏
  const financeAvailable=access['finance-management'];
  const plansItem = showWorkspace&&financeAvailable ? item('plans') : '';
  const taskTypeLabel = ledgerType === 'invoice-ledger' ? '发票台账' : '报关单及发票匹配台账';
  return `<div class="nav-group">${item('tasks')}${item('space')}${plansItem}</div>${showWorkspace&&financeAvailable ? `<div class="nav-group"><div class="nav-section-label">财务管理模块</div><div class="nav-task-type-label">${taskTypeLabel}</div>${workflowItems}</div>` : ''}`;
}
